<template>
  <v-data-table
    mobile-breakpoint="0"
    :items-per-page="-1"
    item-key="id"
    :items="months"
    :headers="headers"
    hide-default-footer
    loading-text="Đang Tải"
  >
    <template v-slot:[`item.title`]="{ item }">
      <a @click="goToDetail(item)">{{ item.title }}</a>
    </template>
    <template v-slot:[`item.totalPaid`]="{ item }">
      <span>{{ feePaidMonths[item.index] | price }}</span>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-btn icon @click="goToDetail(item)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'
import { TuitionFeePeriod, TuitionFeeReport } from '@/plugins/api.js'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Tháng',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true,
          width: '20%'
        },
        {
          text: 'Tổng tiền đã thu',
          value: 'totalPaid',
          align: 'left',
          sortable: false,
          show: true,
          width: '20%'
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'center',
          sortable: false,
          show: true,
          width: '10%'
        }
      ],
      months: [
        {
          title: 'Tháng 6',
          index: 6
        },
        {
          title: 'Tháng 7',
          index: 7
        },
        {
          title: 'Tháng 8',
          index: 8
        },
        {
          title: 'Tháng 9',
          index: 9
        },
        {
          title: 'Tháng 10',
          index: 10
        },
        {
          title: 'Tháng 11',
          index: 11
        },
        {
          title: 'Tháng 12',
          index: 12
        },
        {
          title: 'Tháng 1',
          index: 1
        },
        {
          title: 'Tháng 2',
          index: 2
        },
        {
          title: 'Tháng 3',
          index: 3
        },
        {
          title: 'Tháng 4',
          index: 4
        },
        {
          title: 'Tháng 5',
          index: 5
        }
      ],
      feePaidMonths: {},
      periods: []
    }
  },
  async created() {
    try {
      this.$loading.active = true
      const periods = await TuitionFeePeriod.fetch({})
      const feePaidMonths = await TuitionFeeReport.calculateFeeMonth({})
      this.periods = periods
      this.feePaidMonths = feePaidMonths
    } catch (error) {
      this.$alert.error(error)
    } finally {
      this.$loading.active = false
    }
  },
  methods: {
    ...mapMutations({
      setDetailPeriod: 'tuitionFeePeriod/setDetailPeriod'
    }),
    getFirstDayOfMonth(monthNumber) {
      if (monthNumber < 1 || monthNumber > 12) {
        throw new Error('Số tháng phải từ 1 đến 12')
      }
      return {
        start: moment()
          .month(monthNumber - 1)
          .startOf('month')
          .toISOString(),
        end: moment()
          .month(monthNumber - 1)
          .endOf('month')
          .toISOString()
      }
    },
    goToDetail(item) {
      let period = {}
      if (item.index <= 6) period = this.periods.find(p => p.index === 2)
      else period = this.periods.find(p => p.index === 1)
      const date = this.getFirstDayOfMonth(item.index)
      this.$router.push(`/report-month-detail/${period.id}/${item.index}/${date.start}/${date.end}`)
    }
  }
}
</script>

<style></style>
